var _path, _path2, _g, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoyaltyIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1778",
    "data-name": "Group 1778",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.406,
    height: 37.093,
    viewBox: "0 0 45.406 37.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M560.742,550.653l2.687,2.687,2.4-2.428,2.4,2.428,2.687-2.687-3.189-3.189-1.9-1.9-1.9,1.9Z",
    transform: "translate(-543.124 -536.843)",
    fill: "#658cf8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M565.827,622.734l-2.4-2.428-2.687,2.687,3.189,3.189,1.9,1.9,1.9-1.9,3.189-3.189-2.687-2.687Z",
    transform: "translate(-543.124 -590.985)",
    fill: "#658cf8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1698",
    "data-name": "Group 1698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M598.635,589.8l-2.4-2.428-2.687,2.687,3.189,3.189,1.9,1.9,1.9-1.9,3.189-3.189-2.687-2.687Z",
    transform: "translate(-566.891 -567.125)",
    fill: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M538.1,590.056l-2.687-2.687-2.4,2.428-2.4-2.428-2.687,2.687,3.189,3.189,1.9,1.9,1.9-1.9Z",
    transform: "translate(-519.357 -567.125)",
    fill: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M597.426,519.252l2.4,2.428,2.687-2.687-3.189-3.189-1.9-1.9-1.9,1.9-3.189,3.189,2.687,2.687Z",
    transform: "translate(-566.014 -513.907)",
    fill: "#658cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M534.228,519.252l2.4,2.428,2.686-2.687-3.189-3.189-1.9-1.9-1.9,1.9-3.189,3.189,2.687,2.687Z",
    transform: "translate(-520.233 -513.907)",
    fill: "#658cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M501.97,552.412l2.343-2.315L501.72,547.5l-3.078,3.078-1.83,1.83,1.83,1.83,3.078,3.078,2.593-2.593Z",
    transform: "translate(-496.811 -538.245)",
    fill: "#9bb6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M640.027,550.582l-3.078-3.078-2.593,2.593,2.343,2.315-2.343,2.315,2.593,2.593,3.078-3.078,1.83-1.83Z",
    transform: "translate(-596.451 -538.245)",
    fill: "#9bb6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M530.166,533.717l-5.461,5.461-5.461-5.461L516,536.964l5.461,5.461L516,547.886l2.883,2.883L533.049,536.6Z",
    transform: "translate(-510.71 -528.258)",
    fill: "#c3d3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M597.6,536.964l-3.247-3.247-5.461,5.461-5.451-5.451-2.88,2.88,14.159,14.159,2.88-2.88-5.461-5.461Z",
    transform: "translate(-557.481 -528.258)",
    fill: "#c3d3ff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M559.861,573.717h0l5.122-5.122-.009-.008,0,0-3.247-3.247-5.455,5.455.009.009-.009.009-.009-.009.009-.009-5.451-5.451-3.256,3.256,5.46,5.46-.383.383,0,0-5.085,5.085.01.01.008-.008,3.239,3.239,5.461-5.461,5.461,5.461,3.24-3.239.008.008.007-.007-5.469-5.469Z",
    transform: "translate(-533.573 -551.164)",
    fill: "#2c5cde"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyIc);
export default __webpack_public_path__ + "static/media/loyalty-ic.d8eb70869318817b16f110532d172d97.svg";
export { ForwardRef as ReactComponent };